import { useEffect, useState } from "react";

function seedFromString(seed) {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
  return hash;
}

/**
 * Simulates a live "X people are buying this pack right now" counter.
 * The base value is derived deterministically from the given seed (e.g. product id)
 * so it stays consistent across re-renders, then gently fluctuates over time for realism.
 */
export function useLiveBuyerCount(seed) {
  const [count, setCount] = useState(() => 7 + (seedFromString(String(seed)) % 27));

  useEffect(() => {
    const id = setInterval(() => {
      setCount((c) => Math.max(6, Math.min(48, c + (Math.random() > 0.5 ? 1 : -1) * Math.ceil(Math.random() * 3))));
    }, 8000 + Math.random() * 6000);
    return () => clearInterval(id);
  }, [seed]);

  return count;
}
